import AIART from "./aiart";

export default AIART;
